import * as React from 'react'

import compact from 'lodash-es/compact'
import isEqual from 'lodash-es/isEqual'

import { buildItemClassName } from './buildItemClassName'

import { IItem } from '../../../../../typings/searchResults'
import { IItemRow } from './grid'

const GUTTER_WIDTH = 100 * 16 / 1370

interface IProps {
  rows: IItemRow[]
  itemsPerRow: number
  minWidth: number
  maxWidth: number
}

const buildItemStyle = (
  className: string,
  width: number,
  gutterWidth: number
) => {
  return `.${className} { width: ${width}%; margin-right: ${gutterWidth}%; }`
}

const buildDetailsStyle = (
  className: string,
  width: number,
  marginLeft: number
) => {
  return `.${className} { width: ${width}%; margin-left: ${marginLeft}%; }`
}

const truncateDecimal = (num: number) =>
  parseFloat((num * 10e5).toFixed(0)) / 10e5

const createMediaQuery = (min: number, max: number) =>
  compact([
    min > 0 && `(min-width: ${min}px)`,
    max > 0 && `(max-width: ${max}px)`
  ]).join(' and ')

class GridStyles extends React.Component<IProps> {
  public shouldComponentUpdate(nextProps: IProps) {
    return !isEqual(this.props, nextProps)
  }

  public render() {
    const { rows, itemsPerRow, minWidth, maxWidth } = this.props

    const imageStylesheet = rows
      .reduce<string[]>((cssSelectors, row, rowIndex) => {
        const { items, size } = row
        const numOfGutters = items.length - 1

        items.reduce((itemOffset, item, imageIndex) => {
          const itemClassName = buildItemClassName('item', item.id)
          const detailsClassName = buildItemClassName('details', item.id)

          let { aspectRatio } = item.ui
          aspectRatio = aspectRatio || 1.0

          const smallLastRow =
            rowIndex === rows.length - 1 && size < 0.6 * itemsPerRow
          const rowSize = smallLastRow ? itemsPerRow : size

          const itemWidth =
            (100 - numOfGutters * GUTTER_WIDTH) * aspectRatio / rowSize
          const detailsWidth = 100 * 100 / itemWidth
          const noGutter = imageIndex === numOfGutters
          const itemDetailsMargin = 100 * itemOffset / itemWidth

          const styles = []

          styles.push(
            buildItemStyle(
              itemClassName,
              truncateDecimal(itemWidth),
              noGutter ? 0 : GUTTER_WIDTH
            )
          )

          styles.push(
            buildDetailsStyle(
              detailsClassName,
              truncateDecimal(detailsWidth),
              truncateDecimal(-itemDetailsMargin)
            )
          )

          cssSelectors.push(styles.join(''))

          return itemOffset + itemWidth + GUTTER_WIDTH
        }, 0)

        return cssSelectors
      }, [])
      .join('')

    return (
      <style>
        {`@media ${createMediaQuery(
          minWidth,
          maxWidth
        )} { ${imageStylesheet} }`}
      </style>
    )
  }
}

export default GridStyles
